import * as React from "react";

const ThreeIcon = ({
  fill = "black",
  width = "500px",
  height = "500px",
  rotation = "0",
}) => (
  <svg
    fill={`${fill}33`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 230 230"
    width={width}
    height={height}
    style={{ transform: `rotate(${rotation}deg)` }}
  >
    <g
      transform="translate(-20 -25) scale(1.2)"
      fill-rule="evenodd"
      stroke={`${fill}`}
      stroke-linecap="butt"
      stroke-linejoin="round"
      stroke-width="4"
      opacity={0.3}
    >
      <path d="m63.02 200.61-43.213-174.94 173.23 49.874z" />
      <path d="m106.39 50.612 21.591 87.496-86.567-24.945z" />
      <path d="m84.91 125.03-10.724-43.465 43.008 12.346z" />
      <path d="m63.458 38.153 10.724 43.465-43.008-12.346z" />
      <path d="m149.47 62.93 10.724 43.465-43.008-12.346z" />
      <path d="m84.915 125.06 10.724 43.465-43.008-12.346z" />
    </g>
  </svg>
);

export default ThreeIcon;
